import { IStyle } from '@fluentui/react';
import { msGridUnit } from '../../constants';

export interface ITenantListItemStyles {
  root: IStyle;
}

export const tenantListItemStyles = (isCurrentOrg = false): ITenantListItemStyles => ({
  root: {
    display: isCurrentOrg ? 'flex' : 'block',
    alignItems: 'center',
    marginBottom: `${msGridUnit}px`,
    padding: '6px 20px',
    width: '100%',
    height: '48px',
    border: isCurrentOrg ? 0 : '1px solid #8A8886',
    background: isCurrentOrg ? '#F3F2F1' : '#FFFFFF',
    borderRadius: '2px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    fontFamily: 'Segoe UI',
    minWidth: '40%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    color: '#323130',
    fontWeight: 600,
    lineHeight: '20px'
  }
});
